<div class="crm-container">
  <div class="header-section">
    <h3>CRM</h3>
    <a class="graph-link" [routerLink]="['/agent/crm-graph']">Open CRM Graph</a>
  </div>

  <div class="tab-menu">
    <div class="tab-item" [class.active]="activeTab === 'companies'" (click)="setTab('companies')">Companies</div>
    <div class="tab-item" [class.active]="activeTab === 'performance'" (click)="setTab('performance')">Account Performance</div>
    <div class="tab-item" [class.active]="activeTab === 'brandPerformance'" (click)="setTab('brandPerformance')">Brand Performance</div>
    <div class="tab-item" [class.active]="activeTab === 'contacts'" (click)="setTab('contacts')">Contacts</div>
    <div class="tab-item" [class.active]="activeTab === 'contactPerformance'" (click)="setTab('contactPerformance')">Contact Performance</div>
  </div>

  <!-- Companies Tab -->
  <div *ngIf="activeTab === 'companies'">
    <div class="add-brand-bar">
      <button class="site-button blue" (click)="openAddCompanyDialog()">Add Company</button>
    </div>
    <div *ngIf="loadingCompanies" class="loading-message">Loading companies...</div>
    <div *ngIf="companiesError" class="error-message">{{ companiesError }}</div>
    <div *ngIf="companyDeleteError" class="error-message delete-error">
      {{ companyDeleteError }}
      <button class="dismiss-btn" (click)="companyDeleteError = ''">&#x2715;</button>
    </div>
    <div *ngIf="!loadingCompanies && !companiesError && companies.length === 0" class="no-data-message">No companies found.</div>

    <div *ngIf="!loadingCompanies && companies.length > 0" class="companies-grid">
      <!-- Filter row -->
      <div class="filter-cell">
        <input
          class="filter-input"
          placeholder="Filter companies..."
          [value]="companyFilter"
          (input)="companyFilter = $any($event.target).value"
        />
        <select class="filter-input filter-type" [(ngModel)]="companyTypeFilter">
          <option value="">All types</option>
          <option value="Brand">Brand</option>
          <option value="Agency">Agency</option>
        </select>
      </div>

      <!-- Header row -->
      <div class="col-header">Name</div>
      <div class="col-header">Type</div>
      <div class="col-header">Domains</div>
      <div class="col-header">Bill To</div>
      <div class="col-header">Billing Info</div>
      <div class="col-header col-header-delete"></div>

      <!-- Data rows -->
      <ng-container *ngFor="let company of filteredCompanies">
        <!-- Name -->
        <div class="account-cell name-cell" (click)="startCompanyEdit(company, 'name')" *ngIf="!isEditingCompany(company, 'name')">
          {{ company.name || '—' }}
        </div>
        <div class="account-cell editor-cell" *ngIf="isEditingCompany(company, 'name')">
          <input #companyEditor class="cell-editor" type="text" [(ngModel)]="editingCompanyValue"
            (keydown)="onCompanyEditKeydown($event)" (blur)="commitCompanyEdit()" />
        </div>

        <!-- Type -->
        <div class="account-cell billto-cell" (click)="startCompanyEdit(company, 'type')" *ngIf="!isEditingCompany(company, 'type')">
          {{ company.type || '—' }}
        </div>
        <div class="account-cell editor-cell" *ngIf="isEditingCompany(company, 'type')">
          <select #companyEditor class="cell-editor" [(ngModel)]="editingCompanyValue"
            (change)="commitCompanyEdit()" (blur)="commitCompanyEdit()">
            <option value="">—</option>
            <option *ngFor="let t of companyTypeOptions" [value]="t">{{ t }}</option>
          </select>
        </div>

        <!-- Domains -->
        <div class="account-cell domains-cell" (click)="startCompanyEdit(company, 'domains')" *ngIf="!isEditingCompany(company, 'domains')">
          {{ company.domains || '—' }}
        </div>
        <div class="account-cell editor-cell" *ngIf="isEditingCompany(company, 'domains')">
          <input #companyEditor class="cell-editor" type="text" [(ngModel)]="editingCompanyValue"
            (keydown)="onCompanyEditKeydown($event)" (blur)="commitCompanyEdit()" />
        </div>

        <!-- Bill To -->
        <div class="account-cell billto-cell" (click)="startCompanyEdit(company, 'billTo')" *ngIf="!isEditingCompany(company, 'billTo')">
          {{ company.billTo || '—' }}
        </div>
        <div class="account-cell editor-cell" *ngIf="isEditingCompany(company, 'billTo')">
          <textarea #companyEditor class="cell-editor cell-editor-textarea cell-editor-billto" rows="4"
            [(ngModel)]="editingCompanyValue" (keydown)="onCompanyEditKeydown($event)" (blur)="commitCompanyEdit()"></textarea>
        </div>

        <!-- Billing Info -->
        <div class="account-cell billinginfo-cell" (click)="startCompanyEdit(company, 'billingInfo')" *ngIf="!isEditingCompany(company, 'billingInfo')">
          {{ company.billingInfo || '—' }}
        </div>
        <div class="account-cell editor-cell" *ngIf="isEditingCompany(company, 'billingInfo')">
          <input #companyEditor class="cell-editor" type="text" [(ngModel)]="editingCompanyValue"
            (keydown)="onCompanyEditKeydown($event)" (blur)="commitCompanyEdit()" />
        </div>

        <!-- Delete -->
        <div class="account-cell delete-cell">
          <button class="delete-btn" [class.deleting]="deletingCompanyId === company.id"
            [disabled]="!!deletingCompanyId" (click)="deleteCompany(company)" title="Delete company">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" fill="currentColor">
              <path d="M9 3h6l1 1h4v2H4V4h4L9 3zm-4 5h14l-1.5 13H6.5L5 8zm5 2v9h1V10h-1zm4 0v9h1V10h-1z"/>
            </svg>
          </button>
        </div>
      </ng-container>

      <div *ngIf="filteredCompanies.length === 0" class="no-data-message filter-no-results">
        No companies match the current filter.
      </div>
    </div>
  </div>

  <!-- Account Performance Tab -->
  <div *ngIf="activeTab === 'performance'" class="performance-tab">
    <div *ngIf="loadingPerformance" class="loading-message">Loading account performance...</div>
    <div *ngIf="performanceError" class="error-message">{{ performanceError }}</div>
    <div *ngIf="!loadingPerformance && !performanceError && accountPerformance.length === 0" class="no-data-message">
      No campaign data with linked accounts found.
    </div>

    <div *ngIf="!loadingPerformance && accountPerformance.length > 0" class="perf-chart">
      <div *ngFor="let item of accountPerformance" class="perf-row" (click)="toggleAccount(item.accountId)">
        <div class="bar-track">
          <div class="bar-fill" [style.width.%]="item.widthPercent"></div>
          <span class="bar-label">{{ item.accountName }} &nbsp;&nbsp; {{ formatRate(item.totalRate) }} &nbsp; ({{ item.count }})</span>
        </div>
        <div class="campaign-detail-wrapper" [class.open]="selectedAccountId === item.accountId">
          <div class="campaign-detail-inner">
            <div *ngFor="let c of item.campaigns" class="campaign-item">
              <span class="c-name">{{ c.name }}</span>
              <span class="c-creator">{{ c.creatorName }}</span>
              <span class="c-rate">{{ formatRate(c.rate) }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Brand Performance Tab -->
  <div *ngIf="activeTab === 'brandPerformance'" class="performance-tab">
    <div *ngIf="loadingBrandPerformance" class="loading-message">Loading brand performance...</div>
    <div *ngIf="brandPerformanceError" class="error-message">{{ brandPerformanceError }}</div>
    <div *ngIf="!loadingBrandPerformance && !brandPerformanceError && brandPerformance.length === 0" class="no-data-message">
      No campaign data with linked brands found.
    </div>

    <div *ngIf="!loadingBrandPerformance && brandPerformance.length > 0" class="perf-chart">
      <div *ngFor="let item of brandPerformance" class="perf-row" (click)="toggleBrand(item.brandId)">
        <div class="bar-track">
          <div class="bar-fill" [style.width.%]="item.widthPercent"></div>
          <span class="bar-label">{{ item.brandName }} &nbsp;&nbsp; {{ formatRate(item.totalRate) }} &nbsp; ({{ item.count }})</span>
        </div>
        <div class="campaign-detail-wrapper" [class.open]="selectedBrandId === item.brandId">
          <div class="campaign-detail-inner">
            <div *ngFor="let c of item.campaigns" class="campaign-item">
              <span class="c-name">{{ c.name }}</span>
              <span class="c-creator">{{ c.creatorName }}</span>
              <span class="c-rate">{{ formatRate(c.rate) }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Contacts Tab -->
  <div *ngIf="activeTab === 'contacts'">
    <div class="add-brand-bar">
      <button class="site-button blue" (click)="openAddContactDialog()">Add Contact</button>
    </div>
    <div *ngIf="loadingContacts" class="loading-message">Loading contacts...</div>
    <div *ngIf="contactsError" class="error-message">{{ contactsError }}</div>
    <div *ngIf="contactDeleteError" class="error-message delete-error">
      {{ contactDeleteError }}
      <button class="dismiss-btn" (click)="contactDeleteError = ''">&#x2715;</button>
    </div>
    <div *ngIf="!loadingContacts && !contactsError && contacts.length === 0" class="no-data-message">No contacts found.</div>

    <div *ngIf="!loadingContacts && contacts.length > 0" class="contacts-grid">
      <!-- Filter row: each input sits above the column it filters -->
      <div class="filter-col">
        <input class="filter-input filter-input-sm" placeholder="Name Filter"
          (input)="onContactFilterChange('contactNameFilter', $any($event.target).value)" />
      </div>
      <div class="filter-col">
        <input class="filter-input filter-input-sm" placeholder="Title Filter"
          (input)="onContactFilterChange('contactTitleFilter', $any($event.target).value)" />
      </div>
      <div class="filter-col">
        <input class="filter-input filter-input-sm" placeholder="Role Filter"
          (input)="onContactFilterChange('contactRoleFilter', $any($event.target).value)" />
      </div>
      <div class="filter-col">
        <input class="filter-input filter-input-sm" placeholder="Email Filter"
          (input)="onContactFilterChange('contactEmailFilter', $any($event.target).value)" />
      </div>
      <div class="filter-col"></div>
      <div class="filter-col">
        <input class="filter-input filter-input-sm" placeholder="Company Filter"
          (input)="onContactFilterChange('contactCompanyFilter', $any($event.target).value)" />
      </div>
      <div class="filter-col"></div>
      <div class="filter-col"></div>

      <!-- Header row -->
      <div class="col-header">Name</div>
      <div class="col-header">Title</div>
      <div class="col-header">Role</div>
      <div class="col-header">Email</div>
      <div class="col-header">Phone</div>
      <div class="col-header">Company</div>
      <div class="col-header">Campaigns</div>
      <div class="col-header col-header-delete"></div>

      <!-- Data rows -->
      <ng-container *ngFor="let contact of filteredContacts">
        <!-- Name -->
        <div class="account-cell name-cell" (click)="startContactEdit(contact, 'name')" *ngIf="!isEditingContact(contact, 'name')">
          {{ contact.name || '—' }}
        </div>
        <div class="account-cell editor-cell" *ngIf="isEditingContact(contact, 'name')">
          <input #contactEditor class="cell-editor" type="text" [(ngModel)]="editingContactValue"
            (keydown)="onContactEditKeydown($event)" (blur)="commitContactEdit()" />
        </div>

        <!-- Title -->
        <div class="account-cell billto-cell" (click)="startContactEdit(contact, 'title')" *ngIf="!isEditingContact(contact, 'title')">
          {{ contact.title || '—' }}
        </div>
        <div class="account-cell editor-cell" *ngIf="isEditingContact(contact, 'title')">
          <input #contactEditor class="cell-editor" type="text" [(ngModel)]="editingContactValue"
            (keydown)="onContactEditKeydown($event)" (blur)="commitContactEdit()" />
        </div>

        <!-- Role -->
        <div class="account-cell billto-cell" (click)="startContactEdit(contact, 'role')" *ngIf="!isEditingContact(contact, 'role')">
          {{ roleLabel(contact.role) || '—' }}
        </div>
        <div class="account-cell editor-cell" *ngIf="isEditingContact(contact, 'role')">
          <select #contactEditor class="cell-editor" [(ngModel)]="editingContactValue"
            (change)="commitContactEdit()" (blur)="commitContactEdit()">
            <option value="">—</option>
            <option *ngFor="let r of contactRoleOptions" [value]="r">{{ roleLabel(r) }}</option>
          </select>
        </div>

        <!-- Email -->
        <div class="account-cell billto-cell" (click)="startContactEdit(contact, 'email')" *ngIf="!isEditingContact(contact, 'email')">
          {{ contact.email || '—' }}
        </div>
        <div class="account-cell editor-cell" *ngIf="isEditingContact(contact, 'email')">
          <input #contactEditor class="cell-editor" type="text" [(ngModel)]="editingContactValue"
            (keydown)="onContactEditKeydown($event)" (blur)="commitContactEdit()" />
        </div>

        <!-- Phone -->
        <div class="account-cell billto-cell" (click)="startContactEdit(contact, 'phoneNumber')" *ngIf="!isEditingContact(contact, 'phoneNumber')">
          {{ contact.phoneNumber || '—' }}
        </div>
        <div class="account-cell editor-cell" *ngIf="isEditingContact(contact, 'phoneNumber')">
          <input #contactEditor class="cell-editor" type="text" [(ngModel)]="editingContactValue"
            (keydown)="onContactEditKeydown($event)" (blur)="commitContactEdit()" />
        </div>

        <!-- Company / employer (opens links dialog) -->
        <div class="account-cell links-cell" (click)="openLinksDialog(contact)" title="Manage links">
          <span *ngIf="companyLabel(contact)">{{ companyLabel(contact) }}</span>
          <span *ngIf="!companyLabel(contact)" class="link-add">+ Set</span>
        </div>

        <!-- Campaigns worked (expand inline below the row) -->
        <div class="account-cell links-cell" (click)="toggleContactCampaigns(contact)"
          [class.expanded]="expandedContactId === contact.id" title="Show linked campaigns">
          <span *ngIf="linkedCampaignCount(contact) as count">{{ count }} campaign{{ count === 1 ? '' : 's' }}</span>
          <span *ngIf="!linkedCampaignCount(contact)" class="link-add">+ Link</span>
        </div>

        <!-- Delete -->
        <div class="account-cell delete-cell">
          <button class="delete-btn" [class.deleting]="deletingContactId === contact.id"
            [disabled]="!!deletingContactId" (click)="deleteContact(contact)" title="Delete contact">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" fill="currentColor">
              <path d="M9 3h6l1 1h4v2H4V4h4L9 3zm-4 5h14l-1.5 13H6.5L5 8zm5 2v9h1V10h-1zm4 0v9h1V10h-1z"/>
            </svg>
          </button>
        </div>

        <!-- Expandable linked-campaigns detail (spans full row width) -->
        <div class="contact-campaigns-wrapper" [class.open]="expandedContactId === contact.id">
          <div class="contact-campaigns-inner" *ngIf="expandedContactId === contact.id">
            <div *ngFor="let c of expandedCampaigns" class="campaign-item">
              <span class="c-date">{{ formatDate(c.createdDate) }}</span>
              <span class="c-name">{{ c.name }}</span>
              <span class="c-creator">{{ c.creatorName }}</span>
              <span class="c-rate">{{ formatRate(c.rate) }}</span>
            </div>
            <div *ngIf="!expandedCampaigns.length" class="campaign-empty">No campaigns linked to this contact.</div>
          </div>
        </div>
      </ng-container>

      <div *ngIf="filteredContacts.length === 0" class="no-data-message filter-no-results">
        No contacts match the current filters.
      </div>
    </div>
  </div>

  <!-- Contact Performance Tab -->
  <div *ngIf="activeTab === 'contactPerformance'" class="performance-tab">
    <div *ngIf="loadingContactPerformance" class="loading-message">Loading contact performance...</div>
    <div *ngIf="contactPerformanceError" class="error-message">{{ contactPerformanceError }}</div>
    <div *ngIf="!loadingContactPerformance && !contactPerformanceError && contactPerformance.length === 0" class="no-data-message">
      No campaign data with linked contacts found.
    </div>

    <div *ngIf="!loadingContactPerformance && contactPerformance.length > 0" class="perf-chart">
      <div *ngFor="let item of contactPerformance" class="perf-row" (click)="toggleContact(item.contactId)">
        <div class="bar-track">
          <div class="bar-fill" [style.width.%]="item.widthPercent"></div>
          <span class="bar-label">{{ item.contactName }} &nbsp;&nbsp; {{ formatRate(item.totalRate) }} &nbsp; ({{ item.count }})</span>
        </div>
        <div class="campaign-detail-wrapper" [class.open]="selectedContactId === item.contactId">
          <div class="campaign-detail-inner">
            <div *ngFor="let c of item.campaigns" class="campaign-item">
              <span class="c-name">{{ c.name }}</span>
              <span class="c-creator">{{ c.creatorName }}</span>
              <span class="c-rate">{{ formatRate(c.rate) }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<app-dialog [(visible)]="showAddCompanyDialog">
  <div class="dialog-title">Add Company</div>
  <div class="add-resource-form">
    <div class="input-label">Name</div>
    <div><input class="text-input" [(ngModel)]="newCompanyName" id="companyName" title="Name" type="text" /></div>
    <div class="input-label">Type</div>
    <div>
      <select class="text-input" [(ngModel)]="newCompanyType" id="companyType" title="Type">
        <option *ngFor="let t of companyTypeOptions" [value]="t">{{ t }}</option>
      </select>
    </div>
    <div class="input-label">Domains</div>
    <div><input class="text-input" [(ngModel)]="newCompanyDomains" id="companyDomains" title="Domains" type="text" /></div>
  </div>
  <div *ngIf="addCompanyError" class="error-message">{{ addCompanyError }}</div>
  <div class="button-container">
    <button class="site-button blue" (click)="addCompany()" [disabled]="!newCompanyName.trim() || addingCompany">Add Company</button>
  </div>
</app-dialog>

<app-dialog [(visible)]="showAddContactDialog">
  <div class="dialog-title">Add Contact</div>
  <div class="add-resource-form">
    <div class="input-label">Name</div>
    <div><input class="text-input" [(ngModel)]="newContactName" id="contactName" title="Name" type="text" /></div>
    <div class="input-label">Title</div>
    <div><input class="text-input" [(ngModel)]="newContactTitle" id="contactTitle" title="Title" type="text" /></div>
    <div class="input-label">Role</div>
    <div>
      <select class="text-input" [(ngModel)]="newContactRole" id="contactRole" title="Role">
        <option value="">—</option>
        <option *ngFor="let r of contactRoleOptions" [value]="r">{{ roleLabel(r) }}</option>
      </select>
    </div>
    <div class="input-label">Email</div>
    <div><input class="text-input" [(ngModel)]="newContactEmail" id="contactEmail" title="Email" type="text" /></div>
    <div class="input-label">Phone</div>
    <div><input class="text-input" [(ngModel)]="newContactPhone" id="contactPhone" title="Phone" type="text" /></div>
    <div class="input-label">Company</div>
    <div>
      <select class="text-input" [(ngModel)]="newContactCompanyId" id="contactCompany" title="Company">
        <option value="">—</option>
        <option *ngFor="let c of companies" [value]="c.id">{{ c.name }}{{ c.type ? ' (' + c.type + ')' : '' }}</option>
      </select>
    </div>
  </div>
  <div *ngIf="addContactError" class="error-message">{{ addContactError }}</div>
  <div class="button-container">
    <button class="site-button blue" (click)="addContact()" [disabled]="!newContactName.trim() || addingContact">Add Contact</button>
  </div>
</app-dialog>

<app-dialog [(visible)]="showLinksDialog">
  <div class="dialog-title">Manage Links{{ linksContact ? ' — ' + linksContact.name : '' }}</div>

  <div class="links-section">
    <div class="links-section-title">Employer Company</div>
    <div class="link-add-row">
      <select class="text-input" [ngModel]="linksContact?.companyId || ''" (ngModelChange)="setEmployer($event)" [disabled]="savingLink">
        <option value="">— None —</option>
        <option *ngFor="let c of companies" [value]="c.id">{{ c.name }}{{ c.type ? ' (' + c.type + ')' : '' }}</option>
      </select>
    </div>
  </div>

  <div class="links-section">
    <div class="links-section-title">Campaigns Worked</div>
    <div class="chip-list">
      <span *ngFor="let id of linksContact?.campaignIds" class="link-chip">
        {{ campaignName(id) }}
        <button class="chip-remove" (click)="removeCampaignLink(id)" [disabled]="savingLink" title="Remove">&#x2715;</button>
      </span>
      <span *ngIf="!linksContact?.campaignIds?.length" class="chip-empty">No campaigns linked.</span>
    </div>
    <div class="link-add-row">
      <select class="text-input" [(ngModel)]="linkCampaignToAdd">
        <option value="">Add a campaign…</option>
        <option *ngFor="let c of availableCampaigns()" [value]="c.id">{{ c.name }}</option>
      </select>
      <button class="site-button blue small" (click)="addCampaignLink()" [disabled]="!linkCampaignToAdd || savingLink">Add</button>
    </div>
  </div>

  <div class="links-section" *ngIf="linksContact && derivedBrandNames(linksContact).length">
    <div class="links-section-title">Brands Worked (derived)</div>
    <div class="chip-list">
      <span *ngFor="let name of derivedBrandNames(linksContact)" class="link-chip readonly">{{ name }}</span>
    </div>
  </div>

  <div *ngIf="linkError" class="error-message">{{ linkError }}</div>
</app-dialog>
